/**
 * Після логіну повернути на внутрішній шлях додатку (query `next`).
 * Не приймаємо зовнішні URL / open redirect.
 */
export function sanitizeReturnPath(value) {
    if (value == null) return null;
    let s = String(value).trim();
    if (!s.startsWith("/") || s.startsWith("//")) return null;
    if (s.length > 2048) return null;
    const pathOnly = s.split("?")[0].split("#")[0];
    if (pathOnly === "/login" || pathOnly === "/register") return null;
    const lower = s.toLowerCase();
    if (lower.includes("javascript:") || lower.includes("data:")) return null;
    return s;
}

/** Шлях для редіректу після успішного входу або `null` → головна. */
export function returnPathFromSearchParam(nextParam) {
    if (nextParam == null || nextParam === "") return null;
    try {
        const decoded = decodeURIComponent(String(nextParam));
        return sanitizeReturnPath(decoded);
    } catch {
        return null;
    }
}

/** Рядок для `<Navigate to={...}>` / `navigate(...)` на сторінку логіна з `next`. */
export function loginPathWithReturn(currentPathnameAndSearch) {
    const next = sanitizeReturnPath(currentPathnameAndSearch);
    if (!next) return "/login";
    return `/login?next=${encodeURIComponent(next)}`;
}

/** Відносний URL для `window.location.href` (після refresh / 401). */
export function loginHrefWithReturn(currentPathnameAndSearch) {
    return loginPathWithReturn(currentPathnameAndSearch);
}
